import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  Label,
  Row,
  Col,
  FormGroup,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import TableScrollbar from "react-table-scrollbar";
import moment from "moment";
import Swal from "sweetalert2";
import "../MaterialRequest.scss";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import ChangeItem from "../ChangeItem";
import ProductHistory from "../ProductHistory";
import LoadingModel from "../../LoadingModel";

import {
  ItemQtyChangeValue,
  ItemUnitsChangeValue,
  getReqestRowDetails,
  itemHodApproval,
  MRDeptHodApprovedRequest,
  ChangeItemModelOpen,
  getAllProducts,
  GetProductHistory,
  productItemHistoryModelOpen,
} from "../../../store/MaterialRequest/actions";
import ItemDetails from "../../ItemDetails";
import ProductItemHistoryLog from "../../Material/ProductItemHistoryLog";
import {
  getMiniQUALITY,
  getMiniProductQualities,
} from "../../../store/Mini/actions";

import {
  ProductQualitiesAdd,
  ProductQualitySelecteChangeValue,
  modelClose,
  apiError,
  getProductQualitiesRowData,
  modelOpen,
} from "../../../store/Masters/ProductQuality/action";

function PdfViewer({ url }) {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        let finalUrl = url;

        if (
          window.location.hostname === "localhost" &&
          url.startsWith("http://vendpin.dev.absol.in")
        ) {
          finalUrl = url.replace("http://vendpin.dev.absol.in", "");
        }

        const response = await fetch(finalUrl);
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(blobUrl);
      } catch (err) {
        console.error("Failed to load PDF", err);
      }
    };
    fetchPdf();
  }, [url]);

  if (!pdfBlobUrl)
    return <p style={{ padding: "10px" }}>Loading PDF preview...</p>;

  return (
    <iframe
      src={pdfBlobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}
class DeptMaterialRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item_details: {
        rejectItemText: "",
        rejectErrorMsg: "",
        selectedOrderLocation: null,
        showImageModal: false,
      },
      selectedQualities: {},
      showAddMore: {},
      itemQualities: {},
      currentItemLoading: null,
    };

    this.itemApprovedRequest.bind(this);
    this.tog_static = this.tog_static.bind(this);
    this.reject_Item_Model = this.reject_Item_Model.bind(this);
    this.reject_Model = this.reject_Model.bind(this);
    this.updateRequest = this.updateRequest.bind(this);
  }
  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));

    this.removeBodyCss();
  }

  toggleAddMore = (item) => {
    // Load qualities for this specific item (important!)
    this.loadQualities(item);

    this.setState((prev) => ({
      showAddMore: {
        ...prev.showAddMore,
        [item.id]: !prev.showAddMore[item.id],
      },
    }));
  };

  handleAddMoreSelect = (item, values) => {
    const safeValues = values || []; // <-- ensure it is always an array
    const newQualities = safeValues.map((v) => ({
      id: v.value,
      name: v.label,
    }));

    this.setState((prev) => ({
      selectedQualities: {
        ...prev.selectedQualities,
        [item.id]: newQualities.map((q) => q.id),
      },
    }));
  };

  reject_Item_Model(item) {
    this.setState((prevState) => ({
      rejectItemModel: !prevState.rejectItemModel,
      rejectItem: item,
      rejectItemText: "",
      rejectErrorMsg: "",
    }));
    this.removeBodyCss();
  }
  reject_Model() {
    this.setState((prevState) => ({
      rejectModel: !prevState.rejectModel,
      rejectItemText: "",
      rejectErrorMsg: "",
    }));
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidMount() {
    this.props.getReqestRowDetails(this.props.match.params.id);
  }
  ItemChangeHandeler(e, item) {
    this.props.ItemQtyChangeValue({
      key: e.target.name,
      value: e.target.value,
      item,
      status: "DeptHod",
    });
  }

  itemApprovedRequest = (item, mrstatus) => {
    var data = {
      mrstatus: mrstatus,
      materialrequest_id: this.props.mrRowData.id,
      mritem_id: item.id,
      t_product_id: item.product.id,
      t_qty: item.t_qty == null ? item.qty : item.t_qty,
      t_unit: item.t_unit == null ? item.unit.id : item.t_unit.id,
      t_make: item.t_make == null ? item.make : item.t_make,
      t_description:
        item.t_description == null ? item.description : item.t_description,
      description: this.state.rejectItemText,
      t_quality_ids: this.state.selectedQualities[item.id] || [],
    };

    if (mrstatus === 3) {
      if ((this.state.selectedQualities[item.id] || []).length === 0) {
        Swal.fire("Please select at least one quality!", "", "warning");
        return;
      }
      Swal.fire({
        title: "Are you sure approve this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.itemHodApproval(data);
        }
      });
    }
    if (mrstatus === 4) {
      if (data.description !== "") {
        this.props.itemHodApproval(data);
        this.setState({ rejectItemModel: false });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }
  };

  handleQualitySelect = (itemId, qualityId) => {
    this.setState((prev) => {
      const current = prev.selectedQualities[itemId] || [];

      let updated;
      if (current.includes(qualityId)) {
        // remove if already selected (user unchecks)
        updated = current.filter((id) => id !== qualityId);
      } else {
        // add if newly selected
        updated = [...current, qualityId];
      }

      return {
        selectedQualities: {
          ...prev.selectedQualities,
          [itemId]: updated,
        },
      };
    });
  };

  updateRequest(mrstatus) {
    var mritems = [];
    this.props.mrItemsList.map((item) => {
      if (item.mrstatus === 1 || item.mrstatus === 2) {
        var ItemData = {
          mrstatus: mrstatus,
          materialrequest_id: this.props.mrRowData.id,
          mritem_id: item.id,
          t_product_id: item.product.id,
          t_qty: item.t_qty == null ? item.qty : item.t_qty,
          t_unit: item.t_unit == null ? item.unit.id : item.t_unit.id,
          t_make: item.t_make == null ? item.make : item.t_make,
          t_description:
            item.t_description == null ? item.description : item.t_description,

          description: this.state.rejectItemText,
          t_quality_ids: this.state.selectedQualities[item.id] || [],
        };
        // ItemData['t_description']=''
        mritems.push(ItemData);
      }
      return 0;
    });
    var data = {
      mrstatus: mrstatus,
      materialrequest_id: this.props.mrRowData.id,
      mrias: mritems,
      description: this.state.rejectItemText,
    };
    if (mrstatus === 3) {
      Swal.fire({
        title: "Are you sure approve this MR?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.MRDeptHodApprovedRequest(data, this.props.history);
        }
      });
    }
    if (mrstatus === 4) {
      if (data.description !== "") {
        this.props.MRDeptHodApprovedRequest(data, this.props.history);
        this.setState({ rejectItemModel: false });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }
  }

  loadQualities(item) {
    const { miniProductQualitiesParams } = this.props;

    // Dispatch saga action
    this.props.getMiniProductQualities({
      ...miniProductQualitiesParams,
      page: 1,
      page_size: 50,
      search: "",
      product: item.product?.id,
    });

    // Mark the current item being loaded
    this.setState({ currentItemLoading: item.id });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.miniProductQualitiesList !== this.props.miniProductQualitiesList
    ) {
      const { currentItemLoading, itemQualities } = this.state;

      if (currentItemLoading) {
        const rawResults = this.props.miniProductQualitiesList?.results || [];


        // ✅ Extract qualities from each item
        const allQualities = rawResults.flatMap((item) => item.qualities || []);


        // ✅ Convert final format for dropdown
        const mappedResults = allQualities.map((q) => ({
          ...q,
          label: q.name,
          value: q.id,
        }));


        this.setState({
          itemQualities: {
            ...itemQualities,
            [currentItemLoading]: mappedResults,
          },
          currentItemLoading: null,
        });

      
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <AvForm className="needs-validation">
              <Row>
                <Col md={12}>
                  <Card>
                    <CardHeader className="bg-transparent border-bottom ">
                      <Link
                        to="/mrdashboard2"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>

                      <h5 className="card-title-18 pt-2 d-inline-block">
                        Material Request
                      </h5>
                      <div className="float-right">
                        <div className="d-inline-block ">
                          <Link
                            to={"/mrreportdoc/" + this.props.match.params.id}
                            className="action-icon text-primary mr-2"
                          >
                            <Button
                              type="button"
                              outline
                              color="secondary"
                              className=" mr-2"
                              // href={"/mrreportdoc/" + this.props.match.params.id}
                              // onClick={() => window.print()}
                            >
                              <i className="mdi  mdi-printer"></i>
                              <span className="d-none d-inline-block ml-1">
                                Print
                              </span>
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody className="pt-1 ">
                      <Row className="p-1">
                        <Col xl={4} className="p-1">
                          <Card className="p-1 bg-light">
                            <CardHeader
                              className="bg-transparent"
                              style={{
                                borderBottom: "1px solid #d9d9d9",
                              }}
                            >
                              <h3 className="card-title-15">
                                REQUEST DETAILS (
                                <span>
                                  <b>{this.props.mrRowData.code}</b>
                                </span>
                                )
                              </h3>
                            </CardHeader>
                            <CardBody className="pt-1 bg-light">
                              <Row className="p-0">
                                <Col md="12" className="p-1 m-0">
                                  <div className="Order-panel-content">
                                    <div className="list-column">
                                      <ul className="list-style-three p-0">
                                        <li className="clearfix">
                                          <span className="ttl">
                                            MR Issue status:
                                          </span>
                                          <span className="dtl">
                                            {this.props.mrRowData.mrstatus ===
                                              4 ||
                                            this.props.mrRowData.mrstatus ===
                                              6 ? (
                                              <>
                                                {this.props.mrRowData
                                                  .mrstatus === 4 && (
                                                  <span>HOD Rejected</span>
                                                )}
                                                {this.props.mrRowData
                                                  .mrstatus === 6 && (
                                                  <span>Admin Rejected</span>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {
                                                  this.props.mrRowData
                                                    .mistatus_name
                                                }
                                              </>
                                            )}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">Location:</span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.location
                                                ?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Sub Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.sublocation
                                                ?.name
                                            }
                                          </span>
                                        </li>

                                        <li className="clearfix">
                                          <span className="ttl">
                                            Order Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.orderlocation
                                                ?.name
                                            }

                                            {this.props.mrRowData.orderlocation
                                              ?.image && (
                                              <Button
                                                color="info"
                                                size="sm"
                                                className="ml-2"
                                                onClick={() =>
                                                  this.setState({
                                                    selectedOrderLocation:
                                                      this.props.mrRowData
                                                        .orderlocation,
                                                    showImageModal: true,
                                                  })
                                                }
                                              >
                                                View
                                              </Button>
                                            )}
                                          </span>
                                        </li>
                                        {/* <li className="clearfix">
                                          <span className="ttl">
                                            Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.department
                                                ?.name
                                            }
                                          </span>
                                        </li> */}

                                        <li className="clearfix">
                                          <span className="ttl">
                                            User Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData
                                                .userdepartment?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            User Name:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.createdby
                                                ?.fullname
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Submited Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.mrRowData.createdon
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Required Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.mrRowData.date
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Description:
                                          </span>
                                          <span className="dtl">
                                            {this.props.mrRowData.description}
                                          </span>
                                        </li>

                                        {(this.props.mrRowData.mrstatus === 4 ||
                                          this.props.mrRowData.mrstatus ===
                                            6) && (
                                          <li className="clearfix">
                                            <span className="ttl text-danger ">
                                              Reject Remark :
                                            </span>
                                            <span className="dtl">
                                              {
                                                this.props.mrRowData
                                                  .mr_approvals[
                                                  this.props.mrRowData
                                                    .mr_approvals.length - 1
                                                ].description
                                              }
                                            </span>
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  {!this.props.mrRowData.loading &&
                                    (this.props.mrRowData.mrstatus === 1 ||
                                      this.props.mrRowData.mrstatus === 2) && (
                                      <div className="text-center">
                                        <Button
                                          type="button"
                                          color="danger"
                                          size="lg"
                                          className="waves-effect waves-light mr-2"
                                          onClick={() => this.reject_Model()}
                                        >
                                          <i className="mdi mdi-thumb-down mr-2"></i>{" "}
                                          Reject
                                        </Button>

                                        <Button
                                          type="button"
                                          className="waves-effect waves-light mr-2"
                                          color="success"
                                          size="lg"
                                          onClick={() => {
                                            this.updateRequest(3);
                                          }}
                                        >
                                          <i className="mdi mdi-thumb-up mr-2"></i>
                                          Approve
                                        </Button>
                                      </div>
                                    )}
                                  {this.props.mrRowData.loading && (
                                    <div className="text-center">
                                      <Button
                                        type="button"
                                        className="waves-effect waves-light mr-2"
                                        disabled={true}
                                        size="lg"
                                      >
                                        Loading
                                      </Button>
                                    </div>
                                  )}
                                  {this.props.mrRowData.mrstatus === 3 && (
                                    <div className="text-center border-bottom">
                                      <Label className="font-size-24  text-success">
                                        HOD Approved
                                      </Label>
                                    </div>
                                  )}
                                  {(this.props.mrRowData.mrstatus === 5 ||
                                    this.props.mrRowData.mrstatus === 7 ||
                                    this.props.mrRowData.mrstatus === 8) && (
                                    <div className="text-center border-bottom">
                                      <Label className="font-size-24  text-success">
                                        Admin Approved
                                      </Label>
                                    </div>
                                  )}
                                  {this.props.mrRowData.mrstatus === 4 && (
                                    <div className="text-center ">
                                      <Label className="font-size-24  text-danger">
                                        HOD Rejected
                                      </Label>
                                    </div>
                                  )}
                                  {this.props.mrRowData.mrstatus === 6 && (
                                    <div className="text-center ">
                                      <Label className="font-size-24  text-danger">
                                        Admin Rejected
                                      </Label>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={12} xl={this.state.showImageModal ? 5 : 8}>
                          <Card className="p-1">
                            <CardBody className="pt-1">
                              <Row>
                                <Col md={12}>
                                  <h3 className="card-title-15 pt-2">
                                    Request Items List
                                  </h3>
                                </Col>
                              </Row>
                              <Row className="p-0">
                                <Col md={12} className="m-1">
                                  <div className="table-responsive m-0">
                                    <TableScrollbar height="400px">
                                      <Table
                                        striped
                                        bordered
                                        hover
                                        className="mb-0 p-0 table-centered"
                                      >
                                        <thead className="bg-light text-center">
                                          <tr>
                                            <th className="nowrap">
                                              Item Images
                                            </th>
                                            <th
                                              style={{
                                                minWidth: "120px",
                                              }}
                                            >
                                              Item Name
                                            </th>
                                            <th className="nowrap">Quantity</th>
                                            <th
                                              style={{
                                                minWidth: "120px",
                                              }}
                                            >
                                              Approved Quantity
                                            </th>
                                            <th className="nowrap">
                                              Item Issue
                                            </th>
                                            <th className="nowrap">Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.props.mrItemsList.map(
                                            (item, key) => (
                                              <React.Fragment key={key}>
                                                <tr>
                                                  <td className="text-center">
                                                    <div className="product-detail text-center">
                                                      <img
                                                        src={
                                                          // item?.product?.image ==
                                                          // null
                                                          //   ? DefaultImg
                                                          //   : item?.product?.image
                                                          item
                                                            ?.mritemimages?.[0]
                                                            ?.image
                                                            ? item
                                                                .mritemimages[0]
                                                                .image
                                                            : DefaultImg
                                                        }
                                                        alt="product-img"
                                                        title="product-img"
                                                        className="product-img  img-fluid mx-auto tab-img rounded"
                                                        style={{
                                                          height: "100px",
                                                          width: "150px",
                                                        }}
                                                      />
                                                    </div>
                                                    {/* <img
                                                    src={
                                                      item?.product?.image ==
                                                      null
                                                        ? DefaultImg
                                                        : item?.product?.image
                                                    }
                                                    alt="product-img"
                                                    title="product-img"
                                                    className="avatar-sm"
                                                  /> */}
                                                  </td>
                                                  <td
                                                    style={{
                                                      minWidth: "220px",
                                                    }}
                                                  >
                                                    <h5 className="font-size-14 ">
                                                      <Link
                                                        to="#"
                                                        onClick={() => {
                                                          this.tog_static(item);
                                                        }}
                                                        className="text-dark mr-2"
                                                      >
                                                        {" "}
                                                        {item?.product?.name}
                                                      </Link>
                                                      {!item.product.active && (
                                                        <i className="text-danger ri-spam-line"></i>
                                                      )}
                                                      {item.mri_approvals
                                                        .length !== 0 && (
                                                        <>
                                                          <Link
                                                            to="#"
                                                            onClick={() => {
                                                              this.props.productItemHistoryModelOpen(
                                                                item.mri_approvals
                                                              );
                                                            }}
                                                            className="text-dark"
                                                          >
                                                            <i className=" text-primary ri-eye-fill ml-2"></i>
                                                          </Link>
                                                        </>
                                                      )}

                                                      {item.mri_approvals[0]
                                                        ?.mrstatus !== 9 && (
                                                        <>
                                                          {(item.mrstatus ===
                                                            1 ||
                                                            item.mrstatus ===
                                                              2) && (
                                                            <Link
                                                              to="#"
                                                              onClick={() => {
                                                                this.props.ChangeItemModelOpen(
                                                                  item,
                                                                  "DeptHOD"
                                                                );
                                                                this.props.getAllProducts(
                                                                  {
                                                                    ...this
                                                                      .props
                                                                      .params,
                                                                    search: "",
                                                                    page: 1,
                                                                  },
                                                                  true
                                                                );
                                                              }}
                                                              className="ml-2 text-primary"
                                                            >
                                                              <i className="ri-pencil-line"></i>
                                                            </Link>
                                                          )}
                                                        </>
                                                      )}
                                                      <Link
                                                        to="#"
                                                        onClick={() => {
                                                          this.props.GetProductHistory(
                                                            item.product.id
                                                          );
                                                        }}
                                                        className="ml-2 text-info"
                                                      >
                                                        <i className="ri-history-fill"></i>
                                                      </Link>
                                                    </h5>
                                                    <p className="mb-0">
                                                      <b className="text-dark">
                                                        Make :
                                                      </b>{" "}
                                                      <span>{item.make}</span>
                                                    </p>

                                                    <p className="mb-0">
                                                      <b className="text-dark">
                                                        Description :
                                                      </b>{" "}
                                                      <span>
                                                        {item.description}
                                                      </span>
                                                    </p>
                                                    <p className="mb-0">
                                                      <b className="text-dark">
                                                        Item Info :
                                                      </b>{" "}
                                                      <span>
                                                        {item.item_info}
                                                      </span>
                                                    </p>

                                                    {(item.mrstatus === 4 ||
                                                      item.mrstatus === 6) && (
                                                      <p className="mb-0">
                                                        <b className="text-danger ">
                                                          Reject Remark :
                                                        </b>{" "}
                                                        <span>
                                                          {
                                                            item.mri_approvals[
                                                              item.mri_approvals
                                                                .length - 1
                                                            ].description
                                                          }
                                                        </span>
                                                      </p>
                                                    )}
                                                  </td>
                                                  <td className="text-center">
                                                    {item.mri_approvals
                                                      .length === 0
                                                      ? item.qty +
                                                        " " +
                                                        item.unit?.name
                                                      : item.mri_approvals[0]
                                                          .f_qty +
                                                        " " +
                                                        item.mri_approvals[0]
                                                          .f_unit.name}
                                                  </td>

                                                  <td
                                                    style={{
                                                      minWidth: "220px",
                                                    }}
                                                    className="nowrap text-center"
                                                  >
                                                    {item.mrstatus === 1 ? (
                                                      <>
                                                        <FormGroup
                                                          row
                                                          className="mb-0"
                                                        >
                                                          <Col
                                                            xs={3}
                                                            sm={3}
                                                            md={3}
                                                          >
                                                            <Label
                                                              htmlFor="Qty"
                                                              className="col-form-label float-left"
                                                            >
                                                              Qty :
                                                            </Label>
                                                          </Col>
                                                          <Col
                                                            xs={9}
                                                            sm={9}
                                                            md={9}
                                                          >
                                                            <AvField
                                                              placeholder="Quantity"
                                                              className="pr-0 form-control"
                                                              min={0}
                                                              // max={100}
                                                              type="number"
                                                              // step="1"
                                                              name={key + "qty"}
                                                              id="qty"
                                                              value={item.qty}
                                                              validate={{
                                                                required: {
                                                                  value: true,
                                                                  errorMessage:
                                                                    "Please enter Qty",
                                                                },
                                                                pattern: {
                                                                  value:
                                                                    "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                                                  errorMessage:
                                                                    "Qty can compose numbers and 3 decimals ",
                                                                },
                                                              }}
                                                              onChange={(e) =>
                                                                this.ItemChangeHandeler(
                                                                  e,
                                                                  item
                                                                )
                                                              }
                                                            />
                                                          </Col>
                                                        </FormGroup>
                                                        <FormGroup
                                                          row
                                                          className="mb-0"
                                                        >
                                                          <Col
                                                            xs={3}
                                                            sm={3}
                                                            md={3}
                                                          >
                                                            <Label
                                                              htmlFor="Units"
                                                              className="col-form-label float-left"
                                                            >
                                                              Units :
                                                            </Label>
                                                          </Col>
                                                          <Col
                                                            xs={9}
                                                            sm={9}
                                                            md={9}
                                                          >
                                                            <Select
                                                              id="units_select"
                                                              name="units_select"
                                                              required="required"
                                                              options={item?.product?.units?.map(
                                                                (i) => ({
                                                                  label: i.name,
                                                                  value: i.id,
                                                                })
                                                              )}
                                                              value={{
                                                                label:
                                                                  item.t_unit ==
                                                                  null
                                                                    ? item?.unit
                                                                        ?.name
                                                                    : item
                                                                        .t_unit
                                                                        .name,

                                                                value:
                                                                  item.t_unit ==
                                                                  null
                                                                    ? item?.unit
                                                                        ?.id
                                                                    : item
                                                                        .t_unit
                                                                        .id,
                                                              }}
                                                              onChange={(e) => {
                                                                this.props.ItemUnitsChangeValue(
                                                                  {
                                                                    label:
                                                                      e.label,
                                                                    value:
                                                                      e.value,
                                                                    item,
                                                                    status:
                                                                      "DeptHod",
                                                                  }
                                                                );
                                                              }}
                                                            />
                                                          </Col>
                                                        </FormGroup>
                                                      </>
                                                    ) : (
                                                      item.qty +
                                                      " " +
                                                      item.unit?.name
                                                    )}
                                                  </td>
                                                  <td className="text-center">
                                                    {item.mrstatus === 4 ||
                                                    item.mrstatus === 6 ? (
                                                      <>
                                                        {item.mrstatus ===
                                                          4 && (
                                                          <span>
                                                            HOD Rejected
                                                          </span>
                                                        )}
                                                        {item.mrstatus ===
                                                          6 && (
                                                          <span>
                                                            Admin Rejected
                                                          </span>
                                                        )}
                                                      </>
                                                    ) : (
                                                      <> {item.mistatus_name}</>
                                                    )}
                                                  </td>

                                                  <td className="nowrap text-center">
                                                    {item.mrstatus !== 1 &&
                                                      item.mrstatus !== 2 && (
                                                        <Badge
                                                          className="font-size-14"
                                                          color={
                                                            item.mrstatus ===
                                                              1 ||
                                                            item.mrstatus === 2
                                                              ? "primary"
                                                              : item.mrstatus ===
                                                                  3 ||
                                                                item.mrstatus ===
                                                                  5 ||
                                                                item.mrstatus ===
                                                                  7 ||
                                                                item.mrstatus ===
                                                                  8 ||
                                                                item.mrstatus ===
                                                                  11 ||
                                                                item.mrstatus ===
                                                                  12
                                                              ? "success"
                                                              : "danger"
                                                          }
                                                        >
                                                          {item.mrstatus_name}
                                                        </Badge>
                                                      )}

                                                    {(item.mrstatus === 1 ||
                                                      item.mrstatus === 2) && (
                                                      <>
                                                        <Button
                                                          type="button"
                                                          color="success"
                                                          className="waves-effect waves-light mr-2"
                                                          style={
                                                            item.mrstatus ===
                                                              1 ||
                                                            item.mrstatus === 2
                                                              ? {
                                                                  display:
                                                                    "show",
                                                                }
                                                              : {
                                                                  display:
                                                                    "none",
                                                                }
                                                          }
                                                          disabled={
                                                            item.mrstatus === 1
                                                              ? false
                                                              : true
                                                          }
                                                          onClick={() => {
                                                            this.itemApprovedRequest(
                                                              item,
                                                              3
                                                            );
                                                          }}
                                                        >
                                                          <i className="mdi mdi-check"></i>
                                                        </Button>
                                                        <Button
                                                          type="button"
                                                          color="danger"
                                                          className="waves-effect waves-light"
                                                          style={
                                                            item.mrstatus ===
                                                              1 ||
                                                            item.mrstatus === 2
                                                              ? {
                                                                  display:
                                                                    "show",
                                                                }
                                                              : {
                                                                  display:
                                                                    "none",
                                                                }
                                                          }
                                                          // disabled={
                                                          // 	item.mrstatus ===
                                                          // 	1
                                                          // 		? false
                                                          // 		: true
                                                          // }
                                                          onClick={() =>
                                                            this.reject_Item_Model(
                                                              item
                                                            )
                                                          }
                                                        >
                                                          <i className="mdi mdi-close"></i>
                                                        </Button>
                                                      </>
                                                    )}
                                                  </td>
                                                </tr>

                                                <tr>
                                                  <td
                                                    colSpan="7"
                                                    className="p-2"
                                                  >
                                                    <b>Qualities: </b>

                                                    {(() => {
                                                      const masterQualities =
                                                        this.state
                                                          .itemQualities[
                                                          item.id
                                                        ] || [];

                                                      const existingQualities =
                                                        item?.qualities || [];

                                                      const mergedQualities = [
                                                        ...existingQualities,
                                                        ...masterQualities.filter(
                                                          (mq) =>
                                                            !existingQualities.some(
                                                              (eq) =>
                                                                eq.id === mq.id
                                                            )
                                                        ),
                                                      ];

                                                      return (
                                                        <>
                                                          {/* Display existing + selected */}
                                                          {mergedQualities.length >
                                                          0
                                                            ? mergedQualities.map(
                                                                (q) => {
                                                                  const isPending =
                                                                    item.mrstatus ===
                                                                    1;
                                                                  const isApprovedState =
                                                                    item.mrstatus ===
                                                                      3 ||
                                                                    item.mrstatus ===
                                                                      5;
                                                                  const isRejectedState =
                                                                    item.mrstatus ===
                                                                      6 ||
                                                                    item.mrstatus ===
                                                                      4;

                                                                  const approvedQualities =
                                                                    item.mri_approvals
                                                                      ?.flatMap(
                                                                        (a) =>
                                                                          a.t_qualities ||
                                                                          []
                                                                      )
                                                                      .map(
                                                                        (x) =>
                                                                          x.id
                                                                      ) || [];

                                                                  const isApproved =
                                                                    approvedQualities.includes(
                                                                      q.id
                                                                    );

                                                                  const isSelected =
                                                                    this.state.selectedQualities[
                                                                      item.id
                                                                    ]?.includes(
                                                                      q.id
                                                                    ) || false;

                                                                  return (
                                                                    <label
                                                                      key={q.id}
                                                                      style={{
                                                                        marginRight:
                                                                          "15px",
                                                                      }}
                                                                    >
                                                                      <input
                                                                        type="checkbox"
                                                                        checked={
                                                                          isPending
                                                                            ? isSelected
                                                                            : isApprovedState
                                                                            ? isApproved
                                                                            : false
                                                                        }
                                                                        // disabled={
                                                                        // 	!isPending
                                                                        // }
                                                                        onChange={
                                                                          isPending
                                                                            ? () =>
                                                                                this.handleQualitySelect(
                                                                                  item.id,
                                                                                  q.id
                                                                                )
                                                                            : undefined
                                                                        }
                                                                      />
                                                                      &nbsp;
                                                                      <span
                                                                        style={{
                                                                          color:
                                                                            isApprovedState &&
                                                                            isApproved
                                                                              ? "green"
                                                                              : isRejectedState
                                                                              ? "red"
                                                                              : "#000",
                                                                          fontWeight:
                                                                            isApprovedState &&
                                                                            isApproved
                                                                              ? "bold"
                                                                              : "normal",
                                                                        }}
                                                                      >
                                                                        {q.name}
                                                                      </span>
                                                                    </label>
                                                                  );
                                                                }
                                                              )
                                                            : "-"}

                                                          {/* ADD MORE BUTTON */}
                                                          {item.mrstatus ===
                                                            1 && (
                                                            <button
                                                              className="btn btn-sm btn-primary ml-2"
                                                              onClick={() =>
                                                                this.toggleAddMore(
                                                                  item
                                                                )
                                                              }
                                                            >
                                                              Add More
                                                            </button>
                                                          )}

                                                          {/* MULTI SELECT DROPDOWN */}
                                                          {this.state
                                                            .showAddMore[
                                                            item.id
                                                          ] && (
                                                            <div
                                                              style={{
                                                                width: "300px",
                                                                marginTop:
                                                                  "10px",
                                                              }}
                                                            >
                                                              <Select
                                                                isMulti
                                                                classNamePrefix="react-select"
                                                                options={masterQualities.map(
                                                                  (q) => ({
                                                                    label:
                                                                      q.name,
                                                                    value: q.id,
                                                                  })
                                                                )}
                                                                value={(
                                                                  this.state
                                                                    .selectedQualities[
                                                                    item.id
                                                                  ] || []
                                                                ).map((id) => {
                                                                  const q =
                                                                    masterQualities.find(
                                                                      (x) =>
                                                                        x.id ===
                                                                        id
                                                                    );
                                                                  return q
                                                                    ? {
                                                                        label:
                                                                          q.name,
                                                                        value:
                                                                          q.id,
                                                                      }
                                                                    : null;
                                                                })}
                                                                onChange={(
                                                                  values
                                                                ) =>
                                                                  this.handleAddMoreSelect(
                                                                    item,
                                                                    values
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                        </>
                                                      );
                                                    })()}
                                                  </td>
                                                </tr>
                                              </React.Fragment>
                                            )
                                          )}
                                        </tbody>
                                      </Table>
                                    </TableScrollbar>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>

                        {this.state.showImageModal &&
                          this.state.selectedOrderLocation?.image && (
                            <Col md={12} xl={3}>
                              <Card className="p-1">
                                <CardHeader>
                                  <h5>
                                    Order Location Document:{" "}
                                    {this.state.selectedOrderLocation.name}
                                  </h5>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={() =>
                                      this.setState({
                                        showImageModal: false,
                                      })
                                    }
                                  >
                                    Close
                                  </Button>
                                </CardHeader>
                                <CardBody className="p-0">
                                  {this.state.selectedOrderLocation?.image ? (
                                    (() => {
                                      const rawUrl =
                                        this.state.selectedOrderLocation.image;
                                      const cleanUrl = rawUrl.trim();
                                      const isPdf = /\.pdf(\?.*)?$/i.test(
                                        cleanUrl
                                      );

                                      return isPdf ? (
                                        <PdfViewer url={cleanUrl} />
                                      ) : (
                                        <img
                                          src={cleanUrl}
                                          alt="Order Location"
                                          style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                          }}
                                        />
                                      );
                                    })()
                                  ) : (
                                    <p style={{ padding: 10 }}>
                                      No document available
                                    </p>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                          )}
                      </Row>
                      <CardFooter className="bg-transparent pt-0">
                        <div className="float-right">
                          <Button
                            type="reset"
                            color="light"
                            className="waves-effect waves-light mr-2"
                            href="/mrdashboard2"
                          >
                            Cancel
                          </Button>
                          {!this.props.mrRowData.loading &&
                            (this.props.mrRowData.mrstatus === 1 ||
                              this.props.mrRowData.mrstatus === 2) && (
                              <>
                                <Button
                                  type="submit"
                                  color="success"
                                  onClick={() => {
                                    this.updateRequest(3);
                                  }}
                                  className="waves-effect waves-light mr-2"
                                >
                                  Update & Approve
                                </Button>
                              </>
                            )}
                        </div>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>

            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              ItemLevel="MRLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />

            <Modal
              isOpen={this.state.rejectItemModel}
              toggle={this.reject_Item_Model}
              backdrop="static"
              centered
              // size="lg"
            >
              <ModalHeader
                toggle={() => this.setState({ rejectItemModel: false })}
              >
                Reject Remark
              </ModalHeader>
              <ModalBody className="pt-0">
                <Input
                  className="mb-0 form-control "
                  type="textarea"
                  step="1"
                  name="reject"
                  id="reject_item"
                  value={this.state.rejectItemText}
                  onChange={(e) =>
                    this.setState({
                      rejectItemText: e.target.value,
                    })
                  }
                  placeholder="Reject Description"
                />
                {this.state.rejectErrorMsg !== "" && (
                  <span className="text-danger mt-0">
                    {this.state.rejectErrorMsg}
                  </span>
                )}
                <div className="float-right mt-2">
                  <FormGroup>
                    <Button
                      type="button"
                      color="light "
                      className="waves-effect waves-light d-inline-block mr-2"
                      onClick={() =>
                        this.setState({
                          rejectItemModel: false,
                        })
                      }
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      color="primary"
                      className="waves-effect waves-light d-inline-block"
                      onClick={() => {
                        this.itemApprovedRequest(this.state.rejectItem, 4);
                      }}
                    >
                      Submit
                    </Button>
                  </FormGroup>
                </div>
              </ModalBody>
            </Modal>
            <Modal
              isOpen={this.state.rejectModel}
              toggle={this.reject_Model}
              backdrop="static"
              centered
              // size="lg"
            >
              <ModalHeader toggle={() => this.setState({ rejectModel: false })}>
                Reject Remark
              </ModalHeader>
              <ModalBody className="pt-0">
                <Input
                  className="mb-0 form-control "
                  type="textarea"
                  step="1"
                  name="reject"
                  id="reject_item"
                  value={this.state.rejectItemText}
                  onChange={(e) =>
                    this.setState({
                      rejectItemText: e.target.value,
                    })
                  }
                  placeholder="Reject Description"
                />
                {this.state.rejectErrorMsg !== "" && (
                  <span className="text-danger mt-0">
                    {this.state.rejectErrorMsg}
                  </span>
                )}
                <div className="float-right mt-2">
                  <FormGroup>
                    <Button
                      type="button"
                      color="light "
                      className="waves-effect waves-light d-inline-block mr-2"
                      onClick={() =>
                        this.setState({
                          rejectModel: false,
                        })
                      }
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      color="primary"
                      className="waves-effect waves-light d-inline-block"
                      onClick={() => {
                        this.updateRequest(4);
                      }}
                    >
                      Submit
                    </Button>
                  </FormGroup>
                </div>
              </ModalBody>
            </Modal>
            {/* Change Item Model */}
            <ProductItemHistoryLog />
            <ChangeItem />
            <ProductHistory />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { mrRowData, reqrowdata, mrItemsList, loading } = state.Materialrequest;
  const {
    qualitylist,
    qualityParams,
    miniProductQualitiesList,
    miniProductQualitiesParams,
  } = state.Mini;
  return {
    mrRowData,
    reqrowdata,
    mrItemsList,
    loading,
    qualitylist,
    qualityParams,
    miniProductQualitiesList,
    miniProductQualitiesParams,
  };
};

export default connect(mapStatetoProps, {
  ItemQtyChangeValue,
  ItemUnitsChangeValue,
  getReqestRowDetails,
  itemHodApproval,
  MRDeptHodApprovedRequest,
  ChangeItemModelOpen,
  getAllProducts,
  GetProductHistory,
  productItemHistoryModelOpen,
  getMiniQUALITY,
  getMiniProductQualities,
})(DeptMaterialRequest);
